module.exports = __webpack_public_path__ + "img/pexels-andrew-dick-1139871.e9060a68.jpg";